module.exports = __webpack_public_path__ + "static/media/Movies_API_Fetch.68cf8ab0.PNG";